import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
    // {
    //     path: '',
    //     redirectTo: 'appointments',
    //     pathMatch: 'full'
    // },
    {
        path: 'login',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
    },
    {
        path: '',
        loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'calendar',
        loadChildren: () => import('./pages/calendar/calendar.module').then(m => m.CalendarModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'companies',
        loadChildren: () => import('./pages/companies/companies.module').then(m => m.CompaniesModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'assessment-form/:form/:action/:id',
        loadChildren: () => import('./pages/assessment-form/assessment-form.module').then(m => m.AssessmentFormModule),
        canActivate: [AuthGuard]
    },


    {
        path: 'appointments',
        loadChildren: () => import('./pages/appointments/appointments.module').then(m => m.AppointmentsModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'appointments/:id',
        loadChildren: () => import('./pages/appointments/appointment/appointment.module').then(m => m.AppointmentModule),
        canActivate: [AuthGuard]
    },

    
    {
        path: 'users',
        loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'user',
        loadChildren: () => import('./pages/users/user/user.module').then(m => m.UserModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'user/:id',
        loadChildren: () => import('./pages/users/user/user.module').then(m => m.UserModule),
        canActivate: [AuthGuard]
    },


    {
        path: 'providers',
        loadChildren: () => import('./pages/providers/providers.module').then(m => m.ProvidersModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'providers/:id',
        loadChildren: () => import('./pages/providers/provider/provider.module').then(m => m.ProviderModule),
        canActivate: [AuthGuard]
    },


    {
        path: 'senior-centers',
        loadChildren: () => import('./pages/senior-centers/senior-centers.module').then(m => m.SeniorCentersModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'services',
        loadChildren: () => import('./pages/services/services.module').then(m => m.ServicesModule),
        canActivate: [AuthGuard]
    },


    {
        path: 'kpi-data-entry',
        loadChildren: () => import('./pages/kpi-data-entry/kpi-data-entry.module').then(m => m.KpiDataEntryModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'kpi-data-entry/department/:id',
        loadChildren: () => import('./pages/kpi-data-entry/department/department.module').then(m => m.DepartmentModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'kpi-data-entry/form/:action/:date/:id',
        loadChildren: () => import('./pages/kpi-data-entry/form/form.module').then(m => m.FormModule),
        canActivate: [AuthGuard]
    },

    {
        path: 'call-log',
        loadChildren: () => import('./pages/call-log/call-log.module').then(m => m.CallLogModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'call-log/:id',
        loadChildren: () => import('./pages/call-log/call-log.module').then(m => m.CallLogModule),
        canActivate: [AuthGuard]
    },


    {
        path: 'admin-users',
        loadChildren: () => import('./pages/admin-users/admin-users.module').then(m => m.AdminUsersModule),
        canActivate: [AuthGuard]
    },


    {
        path: 'reports',
        loadChildren: () => import('./pages/reports/reports.module').then(m => m.ReportsModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'reports/activity_report',
        loadChildren: () => import('./pages/reports/activity-report/activity-report.module').then(m => m.ActivityReportModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'reports/reports_builder',
        loadChildren: () => import('./pages/reports/reports-builder/reports-builder.module').then(m => m.ReportsBuilderModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'reports/voucher_balances',
        loadChildren: () => import('./pages/reports/voucher-balances/voucher-balances.module').then(m => m.VoucherBalancesModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'reports/call_log_report',
        loadChildren: () => import('./pages/reports/call-log-report/call-log-report.module').then(m => m.CallLogReportModule),
        canActivate: [AuthGuard]
    },


    {
        path: 'administrative',
        loadChildren: () => import('./pages/administrative/administrative.module').then(m => m.AdministrativeModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'administrative/audit_trail',
        loadChildren: () => import('./pages/administrative/audit-trail/audit-trail.module').then(m => m.AuditTrailModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'administrative/manual_notifications',
        loadChildren: () => import('./pages/administrative/manual-notifications/manual-notifications.module').then(m => m.ManualNotificationsModule),
        canActivate: [AuthGuard]
    },
    
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
